import { Upload } from 'antd';
import type { UploadProps } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';
import { useState } from 'react';
import { styled } from 'styled-components';
import orderApi from '../../apis/order';
import upload from '../../assets/icon/upload.png';
import { IDesign } from '../../interfaces/Order';
import { StyledModal } from '../Modal/SearchDesignModal';

export interface DesignsUploaderProps {
  visible: boolean;
  onUploaded?: (designs: Array<IDesign>) => void;
  onCancel?: () => void;
}

const StyledUpload = styled(Upload)`
  &&.ant-upload-wrapper .ant-upload {
    width: 100%;
    border: 1px dashed var(--color-border) !important;
    background-color: #ffffff;
    border-radius: 8px;
  }
`;

const PlaceHolder = styled.div`
  .main {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--color-light-grey);

    span {
      font-weight: 500;
      color: #155eef;
    }
  }

  .sub {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    color: var(--color-light-grey);
  }
`;

const DesignsUploader = (props: DesignsUploaderProps) => {
  const { visible, onUploaded, onCancel } = props;
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [loading, setLoading] = useState(false);

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const handleSelect = async () => {
    if (fileList.length === 0) {
      return;
    }

    const formData = new FormData();
    if (fileList.length > 0) {
      fileList.map((file) =>
        formData.append('designs', file.originFileObj || '')
      );
    }

    try {
      setLoading(true);
      const res = await orderApi.uploadDesigns(formData);
      setFileList([]);
      onUploaded?.(res);
    } catch (error) {
      // navigate(-1);
      console.error(error);
    } finally {
      setLoading(false);
      onCancel?.();
    }
  };

  const uploadButton = (
    <PlaceHolder>
      <img width={40} src={upload} alt="upload" />
      <p className="main">
        <span>Click to upload</span> or drag and drop
      </p>
      <p className="sub">SVG, PNG, JPG or GIF (max. 800x400px)</p>
    </PlaceHolder>
  );

  return (
    <StyledModal
      visibleModal={visible}
      title={'Upload Designs'}
      // footer={null}
      onPrimaryBtnClick={handleSelect}
      onSecondaryBtnClick={() => {
        setFileList([]);
        onCancel?.();
      }}
      primaryBtn="Upload"
      secondaryBtn="Cancel"
      confirmLoading={loading}
      destroyOnClose={true}
      titleAlign="left"
      headerPadding="0 16px 0"
    >
      <StyledUpload
        className="testt"
        listType="picture-card"
        fileList={fileList}
        onChange={handleChange}
        maxCount={10}
        multiple
        //@ts-ignore
        customRequest={dummyRequest}
      >
        {fileList.length >= 10 ? null : uploadButton}
      </StyledUpload>
    </StyledModal>
  );
};

export default DesignsUploader;
